import { CORE_API } from "../constants";
import { HttpService } from "./http.service";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { HTTP_SERVICE } from "./http.interface";
import { Inject, Injectable } from "@angular/core";
import { CommonInterface } from "./common.interface";
import { BaseResponseModel } from "../models/base-response.model";
import { HeaderCountsModel, NotificationSearchModel, NrSearchModel } from "../models";
@Injectable()

export class CommonService implements CommonInterface {

  constructor(
    @Inject(HTTP_SERVICE) private _httpService: HttpService
  ) { }

  private notificationCountSource = new BehaviorSubject<number>(0);
  notificationCount$ = this.notificationCountSource.asObservable();

  setNotificationCount(count: number): void {
    this.notificationCountSource.next(count);
  }

  // changeFormatUtcToIst<T>(formatedData: BaseResponseModel<T>): any[] {
  //   return formatedData.data.map(item => ({
  //     ...item,
  //     fromDate: item.fromDate
  //       ? new Date(new Date(item.fromDate).getTime() + 330 * 60000)
  //       : null,
  //     toDate: item.toDate
  //       ? new Date(new Date(item.toDate).getTime() + 330 * 60000)
  //       : null,
  //     createdOn: item.createdOn
  //       ? new Date(new Date(item.createdOn).getTime() + 330 * 60000)
  //       : null,
  //     updatedOn: item.updatedOn
  //       ? new Date(new Date(item.updatedOn).getTime() + 330 * 60000)
  //       : null,
  //     validFrom: item.validFrom
  //       ? new Date(new Date(item.validFrom).getTime() + 330 * 60000)
  //       : null,
  //     validTo: item.validTo
  //       ? new Date(new Date(item.validTo).getTime() + 330 * 60000)
  //       : null,
  //   }));
  // }

  changeFormatValidFromUtcToIst<T>(
    formatedData: BaseResponseModel<T>
  ): BaseResponseModel<T> {
    return formatedData.data.map(item => ({
      ...item,
      validFrom: item.validFrom
        ? new Date(new Date(item.validFrom).getTime() + 330 * 60000)
        : null,
      validTo: item.validTo
        ? new Date(new Date(item.validTo).getTime() + 330 * 60000)
        : null
    }));
  }

  getInwardCountData(): Observable<BaseResponseModel<HeaderCountsModel>> {
    return this._httpService.get(CORE_API.GET_INWARD_COUNT);
  }

  getNotificationList(searchModel: NotificationSearchModel): Observable<BaseResponseModel<any>> {
    let params = new HttpParams()
      .set('page', searchModel.page)
      .set('pageSize', searchModel.pageSize);
    if (searchModel.searchText) {
      params = params.set('searchText', searchModel.searchText);
    }
    return this._httpService.get(CORE_API.GET_NOTIFICATIONS_LIST, params);
  }

  notificationMarkAsRead(nrSearchModel: NrSearchModel): Observable<BaseResponseModel<any>> {
    return this._httpService.post(CORE_API.NOTIFICATION_MARK_AS_READ, nrSearchModel);
  }

  getStoreList(): Observable<BaseResponseModel<any>> {
    return this._httpService.get(CORE_API.GET_STORE_LIST);
  }

  getInvoiceList(MaterialTypeId: number, IsReceived: boolean, IsSNMCC: boolean): Observable<BaseResponseModel<any>> {
    let params = new HttpParams()
    params = params.set('materialTypeId', MaterialTypeId);
    params = params.set('isReceived', IsReceived);
    params = params.set('isSNMCC', IsSNMCC);

    return this._httpService.get(CORE_API.GET_INVOICE_LIST, params);
  }

  getNotificationsUnreadCount(): Observable<BaseResponseModel<any>> {
    return this._httpService.get(CORE_API.GET_NOTIFICATIONS_UNREAD_COUNT);
  }

  sendOtp(mobileNo: string, purpose: string): Observable<BaseResponseModel<any>> {
    const body = {
      purpose: purpose,
      mobileNo: mobileNo
    };
    return this._httpService.post(CORE_API.SEND_OTP, body);
  }

  verifyOtp(id: string, otp: string): Observable<BaseResponseModel<any>> {
    let params = { id: id, otp: otp };
    return this._httpService.post(CORE_API.VERIFY_OTP, params);
  }

}